<template>
  <div>
    <i class="fa fa-bar-chart" style="color: rgb(0, 0, 0);margin-right:0px;"></i> Acuvue iLearn 数据统计
    <!-- <p style="color: #2f3e52">
      Acuvue iLearn 数据统计
    </p> -->
    <div style="width: 100%; height: 20px"></div>
    <el-card
      shadow="always"
      style="
        border-radius:16px;
        text-align: left;
        background-color:  rgb(80, 191, 255);
        color: #f7f1ef;
        width: 300px;
        display: inline-block;
        margin-right: 50px;
        cursor: pointer;
      "
    >
    <div style="position: relative;">
        <i class="fa fa-user" style="position: absolute;color: rgb(210, 232, 255); font-size: 50px; right: 0px; top: 10px;"></i>
        <h3 style="margin: 0px 0; font-size: 30px;">
          {{ GetResultNum_list.MemberNum }}
        </h3>
      </div>
      <h2 style="margin: 0px;font-size: 20px;">注册人数</h2>
    
     
    </el-card>
    <el-card
      shadow="always"
      style="
        border-radius:16px;
        text-align: left;
        background-color: rgb(103, 194, 58);
        color: #f7f1ef;
        width: 300px;
        display: inline-block;
        cursor: pointer;
        margin-right: 50px;
      "
    >
    <div style="position: relative;">
        <i class="fa fa-mortar-board" style="position: absolute;color: rgb(210, 232, 255); font-size: 50px; right: 0px; top: 10px;"></i>
        <h3 style="margin: 0px 0; font-size: 30px;">
          {{ GetResultNum_list.MemberCultivateNum }}
        </h3>
      </div>
      <h2 style="margin: 0px;font-size: 20px;">学习人数</h2>
     
    </el-card>
    <el-card
      shadow="always"
      style="
        border-radius:16px;
        text-align: left;
        background-color: rgb(244, 172, 49);
        color: #f7f1ef;
        width: 300px;
        display: inline-block;
        cursor: pointer;
      "
    >

    <div style="position: relative;">
        <i class="fa fa-pencil-square-o" style="position: absolute;color: rgb(210, 232, 255); font-size: 50px; right: 0px; top: 10px;"></i>
        <h3 style="margin: 0px 0; font-size: 30px;">
          {{ GetResultNum_list.MemberExamNum }}
        </h3>
      </div>
      <h2 style="margin: 0px;font-size: 20px;">考试人数</h2>
    </el-card>
  </div>
</template>

<script>
  import Vue from "vue";
  import VCharts from "v-charts";
  Vue.use(VCharts);

  import applicationUserManager from "../Auth/applicationusermanager";
  import {
    getServerInfo,
    // getAccessLogs,
    // getIds4UsersGrow,
    getActiveUsers,
    getAchieveUsers_IS4,
    GetMemberCountList,
  } from "../api/api";

  export default {
    name: "Welcome",
    data() {
      return {
        GetResultNum_list: {},
        listLoading: false,
        welcomeInitData: {
          activeUsers: [],
          activeUserCount: 0,
          logs: [],
          errorCount: 0,
        },
        serverInfo: {},
        extend: {
          series: {
            label: {
              normal: {
                show: true,
              },
            },
          },
        },
        lineChartDataIDS4: {
          columns: [],
          rows: [],
          today: 0,
        },
        lineChartSettings7Day: {
          metrics: ["count"],
          dimension: ["date"],
        },
        lineChartMarkPoint: {
          data: [
            {
              name: "最大值",
              type: "max",
            },
            {
              name: "最小值",
              type: "min",
            },
          ],
        },
      };
    },
    methods: {
      // let GetResultNum = await ClassInfo_GetResultNum();
      getTypeName(count) {
        if (count >= 10 && count < 50) {
          return "warning";
        }
        if (count < 10) {
          return "primary";
        }
        return "danger";
      },
      getBck(index) {
        return `background: rgb(${43 + index * 14}, ${
          148 + index * 7
        }, 255) none repeat scroll 0% 0%;`;
      },
      toLogs() {
        this.$router.replace({
          path: "/Logs/Index",
        });
      },
    },
    async mounted() {
      let GetResultNum = await GetMemberCountList();
      this.GetResultNum_list = GetResultNum.data.response;
      var curTime = new Date();
      if (window.localStorage.TokenExpire) {
        var expiretime = new Date(Date.parse(window.localStorage.TokenExpire));
        if (curTime >= expiretime) {
          if (global.IS_IDS4) {
            applicationUserManager.login();
          } else {
            this.$router.push("/login");
          }
        }
      } else {
        if (global.IS_IDS4) {
          applicationUserManager.login();
        } else {
          this.$router.push("/login");
        }
      }

      if (global.IS_IDS4) {
        getAchieveUsers_IS4({}).then((res) => {
          this.lineChartDataIDS4 = res.data.response;
        });
      }

      getServerInfo({}).then((res) => {
        this.serverInfo = res.data.response;
      });

      getActiveUsers({}).then((res) => {
        this.welcomeInitData = res.data.response;
      });
    },
  };
</script>

<style scoped>
  .amazing /deep/ .el-badge__content {
    background-color: purple !important;
  }
  .bg-blue-sub-item {
    max-width: 120px !important;
    height: 50px;
    float: left;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    padding: 0 10px;
  }
  .bg-blue-sub-item .acc-user {
    max-width: 115px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bg-blue-sub-item-m {
    height: 50px;
    float: left;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    padding: 0 10px;
  }
  .bg-blue-sub-item-m .acc-user {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .note .text {
    font-size: 14px;
  }

  .note .item {
    margin-bottom: 18px;
  }
</style>

<style scoped>
  .panel-group {
    margin-bottom: 18px;
    margin-right: 2%;
  }
  .card-panel-col {
    /* margin-bottom: 32px; */
    width: 113px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-left: 15px;
    float: right;
  }

  .card-panel {
    height: 108px;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
  }

  .card-panel .card-panel-icon-wrapper {
    color: #fff;
  }

  .card-panel .card-panel .icon-people {
    background: #40c9c6;
  }

  .card-panel .card-panel .icon-message {
    background: #36a3f7;
  }

  .card-panel .card-panel .icon-money {
    background: #f4516c;
  }

  .card-panel .card-panel .icon-shopping {
    background: #34bfa3;
  }

  .card-panel .icon-people {
    color: #40c9c6;
  }

  .card-panel .icon-message {
    color: #36a3f7;
  }

  .card-panel .icon-money {
    color: #f4516c;
  }

  .card-panel .icon-shopping {
    color: #34bfa3;
  }

  .card-panel .card-panel-icon-wrapper {
    float: left;
    margin: 14px 0 0 14px;
    padding: 16px;
    transition: all 0.38s ease-out;
    border-radius: 6px;
  }

  .card-panel .card-panel-icon {
    float: left;
    font-size: 48px;
  }

  .card-panel .card-panel-description {
    float: left;
    font-weight: bold;
    margin-left: 30px;
    margin-top: 20px;
  }
  .card-panel .card-panel-description .card-panel-text {
    line-height: 18px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
    margin-bottom: 12px;
  }

  .card-panel .card-panel-description .card-panel-num {
    font-size: 36px;
    color: #f4516c;
  }
  .extoday {
    cursor: pointer;
  }
  .card-acuser-num {
    font-size: 36px;
    color: #40c9c6;
  }
  .bg-blue-sub-item /deep/ .el-badge__content.is-fixed {
    top: 5px !important;
  }
  .bg-blue-sub-item-m /deep/ .el-badge__content.is-fixed {
    top: 5px !important;
  }

  @media (max-width: 550px) {
    .note50 {
      width: 100% !important;
    }
    .statistical-cus {
      width: 100%;
    }

    .card-panel-col {
      margin-bottom: 5px !important;
      width: 100% !important;
    }
    .card-panel-icon-wrapper {
      float: none !important;
      width: 100%;
      height: 100%;
      margin: 0 !important;
    }
    .card-panel-icon-wrapper .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
</style>
<style>
  .el-tooltip__popper {
    width: 80%;
  }
  .el-button--primary {
    background-color: #409eff !important;
    border-color: #409eff !important;
  }
  /* 
  .el-link.el-link--primary:hover {
    color: #2f3e52 !important;
  } */

  .el-link.el-link {
    color: #409eff !important;
  }
  .el-link.is-underline:hover:after {
    border-bottom: 1px solid #409eff !important;
  }
  .el-link.el-link--default:after,
  .el-link.el-link--primary.is-underline:hover:after,
  .el-link.el-link--primary:after {
    border-color: #409eff !important;
  }
  .el-pager li.active {
    color: #409eff !important;
  }
</style>
